module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAICAYAAADN5B7xAAAAt0lEQVQoU2NkQAPWSa952di/72ZgZGD49YPT9eg80c/IShhR1Df8Z3J8+WgTAwODN1R8635xOT+GBsZ/MHUoGpyyHvX8//+/GMVERsbefdPkSjA0OGY/SmL4938uuhPBfCbG5P1T5eaBmGAbnNIf2f1n/A9yNxtWDf8ZfjH+Z3TdN1PuEKNL5kOlvwwMJxkYGESwKkYIvmFmYDBndMx8eJ6BgcGAgGKY9AVGx8xHRxgY/lsTqeEYAJnBNWNDyJg2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/blue_top.png
// module id = Mpf6
// module chunks = 1